import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChallengeActivityService } from '@examdojo/challenge';
import { bufferTime, catchError, concatMap, EMPTY, filter, map, Subject } from 'rxjs';

@Injectable()
export class BatchGradingEffectService {
  constructor(private readonly challengeActivityService: ChallengeActivityService) {
    this.processGradingBuffer().pipe(takeUntilDestroyed()).subscribe();
  }

  private readonly gradedAttemptBuffer$ = new Subject<string>();

  bufferGradedAttempt(attemptId: string): void {
    this.gradedAttemptBuffer$.next(attemptId);
  }

  private processGradingBuffer() {
    return this.gradedAttemptBuffer$.pipe(
      bufferTime(2000),
      filter((ids) => ids.length > 0),
      map((ids) => [...new Set(ids)]),
      concatMap((ids) => this.challengeActivityService.fetchAndUpdateGradingData(ids).pipe(catchError(() => EMPTY))),
    );
  }
}
